/** Apify actor presets — override actor_id in job config when needed. */
export const APIFY_SCRAPE_PRESETS = ['google_maps', 'google_search'];
export const APIFY_PRESET_LABELS = {
    google_maps: 'Google Maps (Places)',
    google_search: 'Google Search (SERP)',
};
/** Default actors on Apify Store (override via config.apify.actor_id). */
export const APIFY_DEFAULT_ACTOR_IDS = {
    google_maps: 'compass/crawler-google-places',
    google_search: 'apify/google-search-scraper',
};
export function buildSearchQueries(segmentation) {
    const fromList = (segmentation.queries ?? []).map((q) => q.trim()).filter(Boolean);
    if (fromList.length)
        return fromList.slice(0, 20);
    const niche = segmentation.niche?.trim();
    const region = segmentation.region?.trim();
    if (niche && region)
        return [`${niche} ${region}`];
    if (niche)
        return [niche];
    if (region)
        return [region];
    return [];
}
export function resolveApifyActorAndInput(preset, segmentation, overrides) {
    const queries = buildSearchQueries(segmentation);
    if (!queries.length) {
        throw new Error('Segmentatie vereist: queries, niche of regio');
    }
    const actor_id = overrides?.actor_id ?? APIFY_DEFAULT_ACTOR_IDS[preset];
    if (preset === 'google_maps') {
        const max = overrides?.max_places ?? 50;
        return {
            actor_id,
            input: {
                searchStringsArray: queries,
                maxCrawledPlacesPerSearch: Math.min(max, 200),
                language: 'nl',
                countryCode: 'nl',
                maxAutomaticZoomOut: 2,
                scrapePlaceDetailPage: true,
                website: true,
                skipClosedPlaces: true,
                ...overrides?.input,
            },
        };
    }
    const max = overrides?.max_places ?? 100;
    const perQuery = Math.max(1, Math.ceil(max / queries.length));
    const maxPagesPerQuery = Math.min(10, Math.max(1, Math.ceil(perQuery / 10)));
    return {
        actor_id,
        input: {
            queries: queries.join('\n'),
            maxPagesPerQuery,
            resultsPerPage: 100,
            countryCode: 'nl',
            languageCode: 'nl',
            /** Apify actor: force NL geo (voorkomt google.com/search?…&gl=us shells) */
            forceExactMatch: false,
            mobileResults: false,
            includeUnfilteredResults: false,
            saveHtml: false,
            saveHtmlToKeyValueStore: false,
            ...overrides?.input,
        },
    };
}
//# sourceMappingURL=apifyPresets.js.map